import { ClickAwayListener } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

interface Props {
  onClose: (ev: MouseEvent | TouchEvent) => Promise<void> | void;
  open: boolean;
  anchorElRef: { current: any };
  children: Array<React.JSX.Element> | React.JSX.Element;
  height?: number;
}

export default function EditorPopper(props: Props) {
  const { onClose, open, anchorElRef, children, height } = props;
  const [position, setPosition] = useState<{ x: number; y: number } | null>(null);

  const positionSettings = useRef({ minWidth: 402, maxHeight: 252 });

  const popperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (anchorElRef.current) {
      positionSettings.current.minWidth = anchorElRef.current.clientWidth > 402 ? anchorElRef.current.clientWidth : 402;
    }
  }, [anchorElRef]);

  useEffect(() => {
    if (open) {
      setPosition(getPosition());
    }
  }, [open, height]);

  const onClosePopper = (ev: MouseEvent | TouchEvent) => {
    onClose(ev);
  };

  const getPosition = () => {
    if (!popperRef.current || !anchorElRef.current) return { x: 0, y: 0 };
    const rootRect = document.querySelector("#root")?.getBoundingClientRect();
    const anchorRect = anchorElRef.current?.getBoundingClientRect();

    if (!rootRect || !anchorRect) return { x: 0, y: 0 };

    const width =
      positionSettings.current.minWidth < popperRef.current.clientWidth &&
      popperRef.current.clientWidth < rootRect.right / 2
        ? popperRef.current.clientWidth
        : positionSettings.current.minWidth;

    const heightChild =
      height || 0 < positionSettings.current.maxHeight ? height || 0 : positionSettings.current.maxHeight;

    const x = anchorRect.right - width < 0 ? 30 : anchorRect.right - width + 30;
    const y =
      anchorRect.top + heightChild < rootRect.bottom - 110 ? anchorRect.top + 27 : anchorRect.top - heightChild - 9;

    return { x, y };
  };

  return (
    <div
      style={{
        position: "fixed",
        zIndex:
          !anchorElRef.current || anchorElRef.current.closest(".background_ModalDialog") === null
            ? "999"
            : anchorElRef.current.closest("DIV.background_ModalDialog").style.zIndex,
        left: position?.x || 0,
        top: position?.y || 0,
      }}
    >
      {open && (
        <ClickAwayListener onClickAway={onClosePopper}>
          <div
            tabIndex={0}
            onWheel={(ev) => {
              ev.stopPropagation();
            }}
            onKeyDown={(ev) => {
              ev.stopPropagation();
            }}
            ref={popperRef}
            style={{
              display: !position ? "none" : "",
              height: "fit-content",
              maxHeight: `${positionSettings.current.maxHeight}px`,
              minHeight: "30px",
              minWidth: `${positionSettings.current.minWidth}px`,
              boxShadow: "rgba(0, 0, 0, 0.2) 3px 3px 3px 2px",
              border: "1px solid #cccccc",
              borderRadius: "7px",
              backgroundColor: "white",
              padding: "5px 5px 5px 5px",
            }}
          >
            {children}
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
}
